import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { phoneImage, portalFeaturesLeft, portalFeaturesRight } from "@/mocks/ppcare";

export default function EmpowerSection() {
  return (
    <section id="portal" className="bg-background-50 py-16 md:py-24">
      <div className="container">
        <Reveal>
          <SectionHeading
            eyebrow="Empower Yourself"
            title={
              <>
                Take Control of Your <span className="text-accent-500">Health</span>
              </>
            }
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 items-center gap-12 lg:grid-cols-[1fr_auto_1fr]">
          <div className="flex flex-col gap-9">
            {portalFeaturesLeft.map((feature, index) => (
              <Reveal key={feature.title} delay={index * 80}>
                <div className="flex items-start gap-5">
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-foreground-900">{feature.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                      {feature.text}
                    </p>
                    <div className="mt-4 h-0.5 w-16 bg-accent-400" />
                  </div>
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-primary-100 text-2xl text-primary-600">
                    <i className={feature.icon} />
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal className="flex justify-center" delay={120}>
            <div className="animate-floaty">
              <img
                src={phoneImage}
                alt="Telemedicine video visit with a Personal Physician Care doctor"
                className="w-[240px] object-contain md:w-[290px]"
              />
            </div>
          </Reveal>

          <div className="flex flex-col gap-9">
            {portalFeaturesRight.map((feature, index) => (
              <Reveal key={feature.title} delay={index * 80}>
                <div className="flex items-start gap-5">
                  <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-primary-100 text-2xl text-primary-600">
                    <i className={feature.icon} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-bold text-foreground-900">{feature.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                      {feature.text}
                    </p>
                    <div className="mt-4 h-0.5 w-16 bg-accent-400" />
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}